import { useSelector } from "react-redux";
import { selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { ILabelDragAndDropQuiz } from "../../../models/interactions/LabelDragAndDropQuiz";
import { useTrainingLocalization } from "../../trainingLocalization/TrainingLocalizationHooks";
import PiInteractionTitlePreview from "../components/PiInteractionTitlePreview";
import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import LabelDragAndDropQuizPreviewBody from "./LabelDragAndDropQuizPreviewBody";

export default function LabelDragAndDropQuizPreview() {
  const quiz = useSelector(selectSelectedElement) as ILabelDragAndDropQuiz;
  const { getValue, changeValue } = useTrainingLocalization();

  const title = (
    <PiInteractionTitlePreview
      value={getValue(quiz.title)}
      onChange={(newValue, shortcode) =>
        changeValue(quiz.title, newValue, shortcode)
      }
      placeholder="Quiz Title"
      key={quiz.id}
    />
  );

  return (
    <PiPopupWindowPreview
      size="large"
      title={title}
      body={<LabelDragAndDropQuizPreviewBody />}
    />
  );
}
